import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GroupByNumberTypePipe } from './group-by-number-type.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { StripHtmlTagsPipe } from './strip-html-tags.pipe';

const SHARED_PIPES = [
  SafeHtmlPipe,
  StripHtmlTagsPipe,
  GroupByNumberTypePipe
];

@NgModule({
  declarations: SHARED_PIPES,
  exports: SHARED_PIPES,
  imports: [
    CommonModule,
  ]
})
export class PipeModule {
  static forRoot() {
    return {
      ngModule: PipeModule,
      providers: [],
    };
  }
}
